import { render, staticRenderFns } from "./CheckBoxPlacePay.vue?vue&type=template&id=929722e6&scoped=true"
import script from "./CheckBoxPlacePay.vue?vue&type=script&lang=js"
export * from "./CheckBoxPlacePay.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxPlacePay.vue?vue&type=style&index=0&id=929722e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929722e6",
  null
  
)

export default component.exports